import { useEffect, useState } from "react";

const CountrySelectorModal = ({ onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const selectedCountry = localStorage.getItem("selectedCountry");
    if (!selectedCountry) {
      setIsOpen(true);
    } else {
      onSelect(selectedCountry);
    }
  }, [onSelect]);

  const handleSelect = (country) => {
    localStorage.setItem("selectedCountry", country);
    onSelect(country);
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-[#040404]/90 backdrop-blur-sm flex justify-center items-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl overflow-hidden max-w-md w-full">
        {/* Modal Header */}
        <div className="bg-gradient-to-r from-[#7bbf42] to-[#f9b414] p-6">
          <h2 className="text-2xl font-bold text-white text-center">
            Where would you like to explore?
          </h2>
          <p className="text-white/90 text-center mt-1">
            Select your country to get personalized services
          </p>
        </div>
        
        {/* Modal Body */}
        <div className="p-6 space-y-4">
          <button
            onClick={() => handleSelect("bangladesh")}
            className="w-full flex items-center justify-between p-4 rounded-xl border-2 border-[#7bbf42]/20 hover:border-[#7bbf42] transition-all duration-300 group"
          >
            <div className="flex items-center space-x-4">
              <span className="text-3xl">🇧🇩</span>
              <div className="text-left">
                <h3 className="font-bold text-[#040404] group-hover:text-[#7bbf42]">Bangladesh</h3>
                <p className="text-sm text-[#040404]/80">Construction Services</p>
              </div>
            </div>
            <div className="w-6 h-6 rounded-full border-2 border-[#7bbf42] flex items-center justify-center">
              <div className="w-3 h-3 rounded-full bg-[#7bbf42] opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          </button>

          <button
            onClick={() => handleSelect("saudiarabia")}
            className="w-full flex items-center justify-between p-4 rounded-xl border-2 border-[#f9b414]/20 hover:border-[#f9b414] transition-all duration-300 group"
          >
            <div className="flex items-center space-x-4">
              <span className="text-3xl">🇸🇦</span>
              <div className="text-left">
                <h3 className="font-bold text-[#040404] group-hover:text-[#f9b414]">Saudi Arabia</h3>
                <p className="text-sm text-[#040404]/80">Construction Services</p>
              </div>
            </div>
            <div className="w-6 h-6 rounded-full border-2 border-[#f9b414] flex items-center justify-center">
              <div className="w-3 h-3 rounded-full bg-[#f9b414] opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          </button>
        </div>

        {/* Modal Footer */}
        <div className="bg-[#040404]/5 p-4 text-center">
          <p className="text-xs text-[#040404]/60">
            You can change this later in the navigation
          </p>
        </div>
      </div>
    </div>
  );
};

export default CountrySelectorModal;